module.exports = __webpack_public_path__ + "img/card-show-bg1-btn2.23d7cc3b.png";